import { FC, useEffect, useMemo, useState } from 'react';
import { FormInput, Modal } from '@praktio/common-ui';
import { useDispatch, useSelector } from 'react-redux';
import { cloneDeep } from 'lodash';

import { RootState } from '../../ducks/store';
import { getCourses } from '../../ducks/courses';
import Table from '../common/Table/Table';

import './AssignCourseModal.scss';

interface ComponentProps {
  onApply: (courses: ICourse[]) => void;
  onHide: () => void;
  show: boolean;
  assignedCourses: ICourse[];
}

const AssignCourseModal: FC<ComponentProps> = ({ onApply, onHide, show, assignedCourses }) => {
  const dispatch = useDispatch();
  const { courses } = useSelector((state: RootState) => {
    return {
      courses: state.courses.list || [],
    };
  });

  useEffect(() => {
    if (show) {
      dispatch(getCourses());
    }
  }, [dispatch, show]);

  const [selections, setSelections] = useState<IKey>({});
  const unassignedCourses = courses.filter((c) => !assignedCourses.find((ac) => ac._id === c._id));
  const data = unassignedCourses.map((c) => {
    const course = cloneDeep(c);
    const courseId = course._id as string;
    const isSelected = selections[courseId];
    course.titleElement = (
      <FormInput
        type="switch"
        fullWidth
        fieldName="isSelected"
        label={course.title}
        value={isSelected}
        largeSwitch
        onChange={() => {
          setSelections({ ...selections, [courseId]: !isSelected });
        }}
      />
    );

    return course;
  });

  const columns = useMemo(
    () => [{ Header: 'Course', accessor: 'titleElement', filterAccessor: 'title' }],
    [],
  );

  return (
    <Modal
      className="AssignCourseModal"
      title="Assign Courses"
      description="Assign courses to a user"
      onSave={() => {
        const selectedCourses: ICourse[] = [];
        Object.keys(selections).forEach((id) => {
          const course = courses.find((c) => c._id === id);
          if (selections[id] && !!course) {
            selectedCourses.push(course);
          }
        });

        onApply(selectedCourses);
        onHide();
      }}
      onHide={() => {
        onHide();
      }}
      show={show}
      saveText="APPLY"
    >
      <Table columns={columns} data={data} pageSize={7} />
    </Modal>
  );
};

export default AssignCourseModal;
